import { type MarketplaceProductCategory } from 'components/marketplace/shared/types'
import MarketplaceProductBadge from 'components/members/components/MarketplaceProductBadge/MarketplaceProductBadge'
import { SkeletonItem } from 'components/reusable/SkeletonItem'
import { type MarketplaceProduct } from 'utils/web_api.schemas'

interface MarketplaceProductCardProps {
  product?: MarketplaceProduct;
  isLoading?: boolean;
}

const MarketplaceProductCard: React.FC<MarketplaceProductCardProps> = ({
  product,
  isLoading,
}) => {
  if (isLoading || !product) {
    return (
      <div
        data-testid='marketplace-product-card-skeleton'
        className='w-full h-full bg-white rounded-lg border border-gray-200 shadow-sm flex flex-row gap-3 p-3'
      >
        {/* Image placeholder */}
        <SkeletonItem heightClass='h-24' widthClass='w-32' />
        <div className='flex flex-col gap-2'>
          {/* Badge placeholder */}
          <SkeletonItem heightClass='h-6' widthClass='w-16' />
          {/* brand, product name, and price placeholders */}
          <div className='w-40'>
            <SkeletonItem heightClass='h-3' widthClass='w-20' />
            <SkeletonItem heightClass='h-4' widthClass='w-full' />
            <SkeletonItem heightClass='h-3' widthClass='w-20' />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      data-testid='marketplace-product-card'
      className='w-full h-full bg-white rounded-lg border border-gray-200 shadow-sm flex flex-row gap-3 p-3'
    >
      {product.image_url && (
        <div className='w-32 h-24 shrink-0 bg-white rounded-lg'>
          <img
            src={product.image_url}
            alt={`Picture of ${product.name}`}
            className='w-full h-full rounded-lg object-cover'
          />
        </div>
      )}
      <div className='flex-grow'>
        <div>
          <MarketplaceProductBadge
            category={product.categories[0] as MarketplaceProductCategory}
          />
          <h3 className='body-sm text-main text-gray-500 mt-1'>
            {product.product_brand}
          </h3>
          <p className='body-bold text-main text-gray-800 mb-2'>
            {product.name}
          </p>
        </div>
        <p className='body-sm text-main text-gray-800'>
          from {product.base_price.formatted_amount}
        </p>
      </div>
    </div>
  )
}

export default MarketplaceProductCard
